export default "__VITE_ASSET__BjaOmBjQ__"